import React from 'react';
import { motion } from 'framer-motion';
import { FiMail } from 'react-icons/fi';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerParticles = Array.from({ length: 18 }, (_, i) => ({
    id: i,
    delay: i * 0.3,
    duration: 5 + Math.random() * 4,
    left: Math.random() * 100,
    top: Math.random() * 100,
    size: Math.random() * 4 + 1,
  }));

  const companyLinks = [
    { name: 'World Mobile', href: 'https://worldmobile.io' },
    { name: 'Minutes Network', href: 'https://minutesnetwork.io' }
  ];

  return (
    <motion.footer
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
      className="relative bg-black text-white py-6 overflow-hidden border-t border-cyan-400/20"
    >
      {/* Background Effects */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-0 left-0 w-96 h-96 bg-cyan-400/10 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-0 w-80 h-80 bg-purple-500/10 rounded-full blur-3xl" />
        {footerParticles.map((particle) => (
          <motion.div
            key={particle.id}
            className="absolute bg-gradient-to-r from-cyan-400 to-blue-400 rounded-full opacity-40"
            style={{
              left: `${particle.left}%`,
              top: `${particle.top}%`,
              width: `${particle.size}px`,
              height: `${particle.size}px`,
            }}
            animate={{
              y: [-15, 15, -15],
              x: [-8, 8, -8],
              opacity: [0.2, 0.6, 0.2],
              scale: [0.6, 1.4, 0.6],
            }}
            transition={{
              duration: particle.duration,
              repeat: Infinity,
              delay: particle.delay,
              ease: 'easeInOut',
            }}
          />
        ))}
      </div>

      {/* Footer Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex flex-col md:flex-row justify-between items-center md:items-start gap-6 md:gap-8 mb-6">
          {/* Left: Company Links */}
          <div className="flex flex-wrap items-center justify-center md:justify-start gap-4 sm:gap-6 text-sm text-gray-300">
            {companyLinks.map((link, i) => (
              <a
                key={i}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white transition whitespace-nowrap"
              >
                {link.name}
              </a>
            ))}
          </div>

          {/* Right: Contact & Addresses */}
          <div className="text-center md:text-right text-sm w-full md:w-auto">
            {/* Contact Email */}
            <a
              href="mailto:contact@wmmn.io"
              className="inline-flex items-center justify-center md:justify-end space-x-2 text-gray-300 hover:text-white transition mb-4 md:mb-4"
            >
              <FiMail className="text-gray-400 flex-shrink-0" />
              <span>contact@wmmn.io</span>
            </a>

            {/* Addresses */}
            <div className="space-y-4 text-gray-300 text-xs sm:text-sm leading-relaxed">
              {/* WMMN Gibraltar */}
              <div>
                <p className="font-semibold text-white mb-1">WMMN</p>
                <p>Address for Rock 4 Eurocomms,</p>
                <p>Gibraltar, GX11 1AA</p>
              </div>

              {/* WMMN USA LLC */}
              <div>
                <p className="font-semibold text-white mb-1">WMMN USA LLC</p>
                <p>14192 Coastal Highway, Lewes</p>
                <p>Delaware 19958, Country of Sussex</p>
                <p>USA</p>
                <a href="tel:+16066468837" className="hover:text-white transition inline-block mt-1">
                  Tel: +1 606 646 8837
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="text-center text-xs text-gray-500 mt-4 pt-4 border-t border-gray-800">
          © {currentYear} World Mobile × Minutes Network
        </div>
      </div>
    </motion.footer>
  );
};

export default Footer;
